<template>
  <div class="enquiryList m-b-100">
    <div v-if="lists && lists.length > 0">
      <inquiry-item :lists="lists" @undo="undoHandle"></inquiry-item>
    </div>
    <z-empty v-else txt="暂时还没有询价单哦！" :sl="false"></z-empty>
  </div>
</template>

<script>
import axios from "axios";
import { constructQueryParams } from "../../../utils/queryParams.js";
import InquiryItem from "@/components/inquiry-item";

const filter = {
  keyword: "",
  pageNum: 0,
  pageSize: 0,
  projectId: ""
};
export default {
  name: "EnquiryList",
  data() {
    return {
      lists: []
    };
  },
  components: {
    InquiryItem
  },
  beforeRouteEnter(to, from, next) {
    filter.projectId = to.params.id;
    axios
      .post(`/designer_api/inquiry`, filter, { globalLoading: true })
      .then(res => {
        next(vm => {
          vm.lists = res;
        });
      });
  },
  methods: {
    getLists() {
      axios
        .post(`/designer_api/inquiry`, filter, { globalLoading: true })
        .then(res => {
          this.lists = res;
        });
    },
    /* 撤销 */
    undoHandle() {
      this.$Modal.confirm({
        loading: true,
        width: 450,
        content: `<div class="projectSwitch"> <p><i class="iconfont icon-jinggao1 dialog-content-error"></i></p> <p>是否撤销本次询价？</p></div>`,
        onOk: () => {
          axios
            .put(`/designer_api/projects/${this.$route.params.id}/cancel`)
            .then(res => {
              this.$Message.success("撤销成功");
              this.getLists();
              this.$Modal.remove();
            })
            .catch(err => {
              this.$Modal.remove();
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.enquiryList {
  width: 99%;
  margin: 0 auto;
  margin-top: 20px;
}
</style>


